import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter as Router, Route } from "react-router-dom";
import './bootstrap';
import { Home } from './landing/index';

class Marketplace extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div>
                <Router>
                    <Route exact path="/home"><Home /></Route>
                </Router>
            </div>
        );
    }
}

export default hot(Marketplace);
ReactDOM.render(<Marketplace />, document.getElementById('app'));
if (process.env.NODE_ENV === 'development' && module.hot)
    module.hot.accept()

